import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class FeaturedImageGrid extends React.PureComponent<FeaturedImageGrid.Props, FeaturedImageGrid.State> {
  public static sectionId = 'figrid';

  public render(): JSX.Element {
    const { settings, blocks } = this.props.section
    const images = blocks?.map((block: any) => block.settings)
    return (
      <section className={'featured-image-grid'}>
        <div className={'max-w-6xl mx-auto'}>
          {settings.heading && (
            <Snippets.Heading tag={'h5'} className={'mb-2 md:mb-10 px-1 leading-none text-center'}>
              {settings.heading}
            </Snippets.Heading>
          )}
          {images?.length && (
            <div className={'flex flex-col lg:flex-row gap-4 md:gap-2 justify-center'}>
              {images.map((image: any, i: number) => {
                return (
                  <div key={i} className={'w-full lg:w-1/2 relative'}>
                    <Snippets.Image
                      alt={'Featured image grid image'}
                      className={'bg-cover bg-center absolute inset-0 h-full'}
                      ratio={'1:1'}
                      src={image.image}
                    />
                    <div className={'absolute h-full w-full top-0 left-0 p-4 flex flex-col items-start justify-between'}>
                      <Snippets.Heading tag={'h5'} className={'mb-10 leading-none text-white text-base'}>
                        {image.heading}
                      </Snippets.Heading>
                      <Snippets.Button
                        onClick={() => trackPromotionClick(
                          [{
                            id: `${this.props.section.id}-block-${i}`,
                            name: settings.title,
                            creative: 'Feature image grid content',
                            position: `${i}`
                          }],
                          image.linkurl
                        )}
                        colour={'secondary-reverse'}
                        className={'mt-2 uppercase bg-transparent tracking-wider'}
                        title={image.linktext}
                      >
                        {image.linktext}
                      </Snippets.Button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </section>
    )
  }

}

export namespace FeaturedImageGrid {
  export interface Options extends ShopifyNext.Section {
    content: string;
    heading: 'uppercase';
    images: any;
  }
  export interface Props extends GlobalProps {
    section: FeaturedImageGrid.Options;
  }
  export interface State { }
}
